module.exports = __webpack_public_path__ + "static/media/TransactionsList.6d7657c7.xlsx";